import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import { CartModal, CartResponse } from "./types";

export const cartInitialstate: CartModal = {
  cartResponse: {
    items: [],
    shippingAddress: {
      flatAddress: "",
      state: "",
      city: "",
      zipcode: "",
    },
    billingAddress: {
      flatAddress: "",
      state: "",
      city: "",
      zipcode: "",
    },
    subtotal: 0,
    depositFee: 0,
    achFee: 0,
    processingFee: 0,
    finalAmount: 0,
  },
  hasCartItem: false,
  isProcessingCheckout: false,
};

const CartModuleSlice = createSlice({
  name: "cart",
  initialState: cartInitialstate,
  reducers: {
    setHasCartItem: (state: CartModal, action: PayloadAction<boolean>) => {
      state.hasCartItem = action.payload;
    },

    setCartItemListing: (
      state: CartModal,
      action: PayloadAction<CartResponse>,
    ) => {
      state.cartResponse = action.payload;
    },

    setCartItemEmpty: (state: CartModal) => {
      state.cartResponse = {
        items: [],
        shippingAddress: {
          flatAddress: "",
          state: "",
          city: "",
          zipcode: "",
        },
        billingAddress: {
          flatAddress: "",
          state: "",
          city: "",
          zipcode: "",
        },
        subtotal: 0,
        depositFee: 0,
        achFee: 0,
        processingFee: 0,
        finalAmount: 0,
      };
    },

    setIsProcessingCheckout: (
      state: CartModal,
      action: PayloadAction<boolean>,
    ) => {
      state.isProcessingCheckout = action.payload;
    },
  },
});

export const {
  setHasCartItem,
  setCartItemEmpty,
  setCartItemListing,
  setIsProcessingCheckout,
} = CartModuleSlice.actions;
export default CartModuleSlice.reducer;
